'use strict';

import BrandsConfig from '../../core/config/brands.json';

const CURRENT_BRAND_LOCALE_STORAGE_KEY = 'CurrentBrand';

export default angular
  .module('maestro.services.brands', [])
  .service('BrandsService', BrandsService)
  .name;

function BrandsService($log, utils) {

  let currentBrandConfig;

  init();

  angular.extend(this, {
    getBrandConfig: getBrandConfig
  });

  function init() {
    currentBrandConfig = getCurrentBrandConfig();
    utils.setStorageItem(CURRENT_BRAND_LOCALE_STORAGE_KEY, currentBrandConfig.id);
    applyBrand();

    // $log.info(`App brand set to "${currentBrandConfig.id}"`);
  }

  function getBrandConfig() {
    return angular.copy(currentBrandConfig);
  }

  function getCurrentBrandConfig() {
    let brand = getUrlParameterByName('brand');
    let hostname = window.location.hostname;

    if (brand) {
      let currentBrandObj = BrandsConfig.brands
        .find(b => b.urlParameters.some(urlParam => urlParam.toLowerCase() === brand.toLowerCase()));
      if (currentBrandObj) {
        return currentBrandObj;
      }
    }

    let currentBrandObj = BrandsConfig.brands
      .find(b => b.hostnames.some(h => h.toLowerCase() === hostname.toLowerCase()));
    if (currentBrandObj) {
      return currentBrandObj;
    }

    let currentBrandId = utils.getStorageItem(CURRENT_BRAND_LOCALE_STORAGE_KEY);
    if (currentBrandId) {
      currentBrandObj = BrandsConfig.brands.find(b => b.id === currentBrandId);
      if (currentBrandObj) {
        return currentBrandObj;
      }
    }

    if (BrandsConfig.default) {
      currentBrandObj = BrandsConfig.brands.find(b => b.id === BrandsConfig.default);
    } else {
      currentBrandObj = BrandsConfig.brands[0];
    }

    if (!currentBrandObj) {
      throw new Error('No brand provided!');
    }

    return currentBrandObj;
  }

  /**
   * Get URL parameter
   * @param name
   * @return {string|null}
   */
  function getUrlParameterByName(name) {
    try {
      let url = new URL(window.location.href);
      return url.searchParams.get(name);
    } catch (e) {
      // Version for IE
      let url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      let results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return '';
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }

  function applyBrand() {
    cleanMetaTags();
    applyMetaTags();
    applyTitle();
    applyBodyClass();
  }

  function cleanMetaTags() {
    let querySelectors = [
      'link[rel="shortcut icon"]',
      'link[rel="icon"]',
      'link[rel="manifest"]',
      'link[rel="apple-touch-icon"]',
      'meta[name="application-name"]',
      'meta[name="apple-mobile-web-app-title"]',
      'meta[name="msapplication-TileImage"]',
      'meta[name="msapplication-config"]',
    ];
    querySelectors.forEach(selector => {
      [...document.querySelectorAll('head > ' + selector)]
        .forEach(e => e.parentNode && e.parentNode.removeChild(e));
    });
  }

  function applyMetaTags() {
    let brandId = currentBrandConfig.id;

    document.querySelector('head').innerHTML += `
      <link rel="shortcut icon" href="/assets/images/brands/${brandId}/favicon.svg" sizes="any" type="image/svg+xml">
      <link rel="icon" type="image/png" sizes="16x16" href="/assets/favicons/${brandId}/favicon-16x16.png">
      <link rel="icon" type="image/png" sizes="32x32" href="/assets/favicons/${brandId}/favicon-32x32.png">
      <link rel="icon" type="image/png" sizes="48x48" href="/assets/favicons/${brandId}/favicon-48x48.png">
      <meta name="mobile-web-app-capable" content="yes">
      <meta name="theme-color" content="#fff">
      <meta name="application-name" content="${currentBrandConfig.favicons.appName}">
      <link rel="apple-touch-icon" sizes="57x57" href="/assets/favicons/${brandId}/apple-touch-icon-57x57.png">
      <link rel="apple-touch-icon" sizes="60x60" href="/assets/favicons/${brandId}/apple-touch-icon-60x60.png">
      <link rel="apple-touch-icon" sizes="72x72" href="/assets/favicons/${brandId}/apple-touch-icon-72x72.png">
      <link rel="apple-touch-icon" sizes="76x76" href="/assets/favicons/${brandId}/apple-touch-icon-76x76.png">
      <link rel="apple-touch-icon" sizes="114x114" href="/assets/favicons/${brandId}/apple-touch-icon-114x114.png">
      <link rel="apple-touch-icon" sizes="120x120" href="/assets/favicons/${brandId}/apple-touch-icon-120x120.png">
      <link rel="apple-touch-icon" sizes="144x144" href="/assets/favicons/${brandId}/apple-touch-icon-144x144.png">
      <link rel="apple-touch-icon" sizes="152x152" href="/assets/favicons/${brandId}/apple-touch-icon-152x152.png">
      <link rel="apple-touch-icon" sizes="167x167" href="/assets/favicons/${brandId}/apple-touch-icon-167x167.png">
      <link rel="apple-touch-icon" sizes="180x180" href="/assets/favicons/${brandId}/apple-touch-icon-180x180.png">
      <link rel="apple-touch-icon" sizes="1024x1024" href="/assets/favicons/${brandId}/apple-touch-icon-1024x1024.png">
      <meta name="apple-mobile-web-app-capable" content="yes">
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent">
      <meta name="apple-mobile-web-app-title" content="${currentBrandConfig.favicons.appName}">
      <meta name="msapplication-TileColor" content="#fff">
      <meta name="msapplication-TileImage" content="/assets/favicons/${brandId}/mstile-144x144.png">
      <meta name="msapplication-config" content="/assets/favicons/${brandId}/browserconfig.xml">
    `;
  }

  function applyTitle() {
    document.querySelector('head > title').innerHTML = currentBrandConfig.pageTitle;
  }

  function applyBodyClass() {
    // remove old classes
    document.body.classList
      .remove(...BrandsConfig.brands.map(b => b.className).filter(cn => cn !== currentBrandConfig.className));

    // add new class
    document.body.classList
      .add(currentBrandConfig.className);
  }

}
